import type { ReactElement } from "react";
import { CmtsEvidenceContainer } from "../../core/containers/domain/complaintsRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsEvidenceContainer runtime={props.runtime} />;
}

export default Component;
